<template>
  <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
    <feather-icon
      class="hover:text-danger cursor-pointer"
      icon="Trash2Icon"
      svgClasses="h-5 w-5"
      @click="confirmDeleteRecord"
    />
  </div>
</template>

<script>
    export default {
        name: 'CellRendererActions',
        methods: {
          confirmDeleteRecord() {
            this.$vs.dialog({
              type: 'confirm',
              color: 'danger',
              title: `Confirmar eliminación`,
              text: `¿Estás seguro que quieres eliminar el estudiante "${this.params.data.name + ' ' + this.params.data.last_name}"?`,
              accept: () => {
                this.params.onDelete(this.params.data.document);
              },
              acceptText: "Eliminar"
            })
          },
          showNotify(color = false, title, text) {
            this.$vs.notify({
              time: 5000,
              color: color || 'success',
              title: title,
              text: text,
              position: 'top-center',
            })
          },
        }
    }
</script>
